<template>
  <div id="header">
    <Row>
      <Col :xs="0" :sm="0" :md="14" :lg="14" :xl="14">
        <div class="logo-info">
          <p class="name">孤独症测评系统</p>
        </div>
        <IBreadcrumb />
      </Col>

      <Col :xs="4" :sm="2" :md="0" :lg="0" :xl="0">
        <Poptip class="navigation" placement="right-start" v-model="visible">
          <Icon class="nav-icon" type="md-menu" size="32" />
          <ISidebar ref="navigation" slot="content" @on-click="handleClose" />
        </Poptip>
      </Col>

      <Col :xs="20" :sm="22" :md="10" :lg="10" :xl="10" style="display: flex;justify-content: flex-end">
        <span class="areaBanner" @click="showEditArea">{{userType >= 6 && (!institutions || institutions.length <= 1) ? "" : '切换机构'}}</span>
        <div class="login-info">
          <Dropdown placement="bottom-end" trigger="click" @on-click="handleDropdown">
            <strong class="user"><Avatar style="background-color: #1890ff" icon="md-person" size="small" />您好, {{ userName }}</strong>
            <DropdownMenu class="list" slot="list">
              <DropdownItem v-for="item in dropdown" :key="item.name" :name="item.name">
                <Icon :type="item.icon" size="16" style="margin-top: -2px;" /> {{ item.label }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </Col>
    </Row>
    <EditPassword ref="editPassword" />
    <EditArea ref="EditArea" />
    <PersonalMsg ref="personalMsg" />
  </div>
</template>
<script>
import EditArea from "@/layouts/pages/EditArea.vue";
import EditPassword from "@/layouts/pages/EditPassword";
import PersonalMsg from "@/layouts/pages/personalMsg";
import ISidebar from "@/layouts/partials/Sidebar";
import IBreadcrumb from "@/layouts/partials/Breadcrumb";
import {_logout} from "@/services/app"
export default {
  name: "IHeader",
  components: {
    EditPassword,
    EditArea,
    PersonalMsg,
    ISidebar,
    IBreadcrumb
  },
  data: () => ({
    globalTenant: '',
    // 导航可视状态
    visible: false,
    // 用户名
    userName: "",
    userInfo : null,
    userType : null,
    institutions : [],
    // 下拉菜单元素数组
    dropdown: [
      {
        label: "个人资料",
        name: "personalMsg",
        icon: "ios-contact"
      },
      {
        label: "修改密码",
        name: "editPassword",
        icon: "md-lock"
      },
      {
        label: "登出",
        name: "signout",
        icon: "md-log-out"
      }
    ]
  }),
  watch: {
    // 侦听路由变化
    $route() {
      // 手动更新展开的子目录
      this.$nextTick(function () {
        this.$refs["navigation"].updateOpened();
      });
    }
  },
  created() {
    this.userInfo = this.$userSession.getUserInfo();
    this.userType = this.$userSession.getUserType();
    this.institutions = this.$userSession.getInstitutions();
  },
  mounted() {
    this.userName = this.userInfo.username || "Null";
  },
  methods: {
    // 关闭导航
    handleClose(state) {
      this.visible = state;
    },
    // 下拉菜单项
    handleDropdown(name) {
      switch (name) {
        case "editPassword":
          // 修改密码
          this.$refs[name].showModal();
          break;
        case "personalMsg":
          // 修改密码
          this.$refs[name].showModal();
          break;
        default:
          // 退出系统
          this.$Modal.confirm({
            title: "<h2>温馨提示</h2>",
            content: "<h3>确认需要退出系统?</h3>",
            okText: "是",
            cancelText: "否",
            onOk: () => {
              _logout().then(res =>{
                //跳转到登录页面 清空路由
                this.$router.push("/login");
                // location.reload();
              })
            }
          });
      }
    },
    /**
     * 切换租户
     */
    showEditArea(){
      if (this.userType < 6 || (this.institutions && this.institutions.length > 1)){
        this.$refs.EditArea.showModal();
      }

    },
  }
};
</script>
<style lang="postcss">
#header {
  background-color: #1f2d3d;
  color: #fff;
  min-height: 60px;

  & #sidebar {
    height: auto;
    width: 240px;
  }

  & .ivu-poptip-popper[x-placement^="right"] .ivu-poptip-arrow:after,
  & .ivu-poptip-popper[x-placement^="right"] .ivu-poptip-arrow {
    border-right-color: #304156;
  }

  & .ivu-poptip-inner {
    background-color: #304156;
  }

  & .ivu-poptip-body {
    padding: 8px 0;
  }

  & .logo-info {
  display: flex;
  justify-content: space-around;
    float: left;
    width: 220px;
  }

  & .logo {
    float: left;
    height: 40px;
    margin: 10px 16px;
    width: 85px;
    border-radius: 50%;
  }

  & .name {
    font-size: 13px;
    line-height: 40px;
    padding: 12px 0 6px;
  }

  & .sub {
    font-size: 12px;
  }

  & .navigation {
    cursor: pointer;
    margin-left: 16px;
    margin-top: 14px;
  }

  & .login-info {
    margin: 18px 16px 0 0;
    text-align: right;

    & .user {
      color: #fff;
      cursor: pointer;
      display: block;
    }

    & .list {
      text-align: left;
    }
  }
 & .areaBanner{
   margin: 10px;
   margin-top: 20px;
   min-width: 65px;
 }
}
</style>
